/**
 * NextStepsInfo - Information box for next steps after reporting
 */

import React from 'react';
import { Info } from 'lucide-react';

const NextStepsInfo = () => (
  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
    <div className="flex items-start">
      <Info className="h-5 w-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
      <div className="text-sm text-blue-700">
        <p className="font-medium mb-1">Next Steps After Reporting:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>This initial report will be reviewed by management</li>
          <li>A formal investigation may be initiated by authorized personnel for serious incidents</li>
          <li>Root cause analysis and contributing factors will be determined during investigation phase</li>
          <li>Corrective actions will be assigned to prevent recurrence</li>
          <li>External reporting (MCA/MAIB) will be handled if required per regulations</li>
        </ul>
        <p className="mt-3 text-xs text-blue-600">
          <strong>Important:</strong> This form is for factual reporting only. Do not attempt to determine causes - 
          that will be done by qualified investigators if an investigation is required.
        </p>
      </div>
    </div>
  </div>
);

export default NextStepsInfo;